import { createSvg } from '##/icons/Icon/createSvg';

import props from './props';

export default createSvg(props);
